import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Message, Input, Form, Schema, Animation, Button } from 'rsuite';



function withParams(Component) {
  return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



export class Blog_single extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      blog_id: this.props.params.id,
      blog: null,
    };

  }


  // ---------------- componentDidMount--------------------------

  componentDidMount() {

    Send('page/blog/single/' + this.state.blog_id, "", true).then((res) => {


      if (!res.data.blog) {
        this.props.navigation('/404');
      }

      this.setState({
        blog: res.data.blog,
      });


    }).catch((err) => { });

    H1.NavHide();
  }



  // ---------------- componentWillUnmount--------------------------

  componentWillUnmount() {

    H1.NavShow();
  }








  render() {

    this.state.blog && H1.page_name(this.state.blog.name);

    return !this.state.blog ? null : (


      <div className="h-100 mt-4">




        <div className='c-row'>


          <div className="text-center mb-2 py-2 position-relative">

            <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span>
            <span className='fs-6'> {this.state.blog.name} </span>


          </div>


        </div>



        <div className="c-row mt-4">



            {this.state.blog.cover &&
              <img className='br-16' src={this.state.blog.cover} width="100%" />
            }





          {this.state.blog.dis &&

              <div className='align-self-center bg-white br-16 p-3 bg-white br-16 p-3 mt-3'>
      
                <div dangerouslySetInnerHTML={{ __html: this.state.blog.dis }} />
              </div>

           
            }

        </div>




      </div>

    )

  }
}

export default withParams(Blog_single);
